import React, { Component } from 'react';
import { WithStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { Grid, Typography, Button, Menu, MenuItem, List } from '@material-ui/core';
import {
	Settings as SettingsIcon, ArrowDropDownOutlined as ArrowDown, FiberManualRecord as RoundedCircle, NavigateBeforeOutlined as BackIcon, FastfoodOutlined,
} from '@material-ui/icons';
import ContentMoreMenu from '../MilestoneDetails/ContentMoreMenu';
import CircularProgress from '@material-ui/core/CircularProgress';
import ListItem from '@material-ui/core/ListItem';
import Paper from '@material-ui/core/Paper';
import { MyPATDialog, MyPATIconButton, MyPATExpansionPanel, MyPATLink, MyPATTextField, MyPATTextArea, MyPATSelect, MyPATCollapse } from '../../../common';
import SuggestedContentCard from '../MilestoneDetails/SuggestedContentCard'
import SuggestedTestCard from '../MilestoneDetails/SuggestedTestCard'
import courseService from '../../services/courseService';
import WithContent from "../../../mylibrary/containers/WithContent";
import { showMsg } from '../../actions/loaderAlert';
import ResponseBasedACL from '../../../acl/components/ResponseBasedACL';

import _ from 'lodash';
import cx from 'classnames';
import Icon from '@material-ui/core/Icon';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';
import MilestoneCard from '../MilestoneDetails/MilestoneCard'
import ContentList from '../MilestoneDetails/ContentList'
import { formValueSelector } from 'redux-form';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import { styles } from '../../styling/component/MilestoneDetails/MilestoneDetails'

interface MilestoneDetailProps extends WithStyles<typeof styles> {
	courseData: any;
	match: any;
	milestoneArr: any;
	showMsg: (msg: string, vari: string) => void,
	courseDetails: any;
	refreshMilestone: Function;
}

interface MilestoneDetailStates {
	milestoneChaperList: [];
	selectedChapter: any;
	milestoneChaperListInner: [];
	testContentListInner: []
	courses: [];
	selectQuestionDialogOpen: boolean;
	selectQuestionDialogData: {
		noOfQuestions: number;
		replaceIndex: number;
		replaceIndexJ: number;
	};
	selectedTempQuestions: any;
	preSelectedFilterContent: any;
	chapterId: string;
	rightTestArrList: any
	drillerData: {},
	globalDrillerData: any,
	contentType: String
	panelId: String
	selectedDeleteData: {},
	expansionIds: String[],
	selectedContent: [],
}

class MilestoneDetailContent extends Component<MilestoneDetailProps, MilestoneDetailStates> {
	constructor(props: MilestoneDetailProps) {
		super(props);
		this.state = {
			selectedContent: [],
			milestoneChaperList: [],
			selectedChapter: '',
			expansionIds: [],
			milestoneChaperListInner: [],
			testContentListInner: [],
			courses: [],
			selectQuestionDialogOpen: false,
			selectQuestionDialogData: {
				noOfQuestions: 0,
				replaceIndex: -1,
				replaceIndexJ: -1
			},
			selectedTempQuestions: [],
			preSelectedFilterContent: {},
			chapterId: "",
			rightTestArrList: [],
			drillerData: {},
			globalDrillerData: {},
			contentType: "",
			panelId: "",
			selectedDeleteData: {}
		};

		this.selectMyList = this.selectMyList.bind(this);
		this.selectConcept = this.selectConcept.bind(this);
		this.handleContentSelect = this.handleContentSelect.bind(this);
		this.handleBackToTestpaperClick = this.handleBackToTestpaperClick.bind(this);
		this.handleAddContentClick = this.handleAddContentClick.bind(this);
		this.handleSuggestedCntentSelect = this.handleSuggestedCntentSelect.bind(this);
		this.getSelectedChapter = this.getSelectedChapter.bind(this);
	}

	componentDidUpdate() {
		const { milestoneChaperList, globalDrillerData } = this.state;
		const milestoneArrList = _.get(this.props, 'milestoneArr', []);
		if (_.isEmpty(globalDrillerData)) {
			const subSubjectId = _.get(milestoneArrList, 'syllabus[0].subjects[0].subSubjects[0]._id', '');
			if (!_.isEmpty(subSubjectId)) {
				this.getGlobalGoalDriller(subSubjectId);
			}
		}

		if (_.isEmpty(milestoneChaperList)) {
			const chaptersList = _.get(milestoneArrList, 'syllabus[0].subjects[0].subSubjects[0].chapters', []);

			if (!_.isEmpty(chaptersList)) {
				const chapterD = _.get(milestoneArrList, 'syllabus[0].subjects[0].subSubjects[0]._id', '');
				this.setState({ milestoneChaperList: chaptersList, selectedChapter: chapterD })
			}
		}
	}

	getGlobalGoalDriller = (subSubjectId: string) => {
		courseService.getGoalDriller(subSubjectId, 'subSubjectId')
			.then(res => {
				if (res) {
					const globalDrillerData = {
						...res,
						level: 'chapter',
					};
					this.setState({ globalDrillerData });
				}
			});
	}

	selectMyList(data: any, subSubjectD: any) {
		let self = this;
		self.getGlobalGoalDriller(subSubjectD);
		self.setState({ milestoneChaperList: data, selectedChapter: subSubjectD })
	}

	selectConcept(chapterD: any, chapters: any, subSubjectD: any) {
		let { expansionIds } = this.state;
		if (!expansionIds.includes(chapterD)) {
			expansionIds.pop();
			expansionIds.push(chapterD);

		} else {
			expansionIds = expansionIds.filter(id => id != chapterD);
		}
		if (chapters != null && subSubjectD != null) {
			this.selectMyList(chapters, subSubjectD)
		}
		this.setState({
			expansionIds
		});

		this.displayContent(chapterD, false);
	}

	getParamsDetail() {
		let courseIDArr = window.location.href.split("/")
		return { courseID: courseIDArr[5], milestoneId: courseIDArr[6] };
	}

	displayContent(chaperId: string, isSubmilestone: boolean = false) {
		let self = this;
		let { milestoneArr } = this.props;
		let _getElement = document.getElementById(chaperId) as HTMLImageElement;
		let paramDetail = this.getParamsDetail();

		if (isSubmilestone) {
			let chapterArray = milestoneArr.syllabus[0].subjects[0].subSubjects[0].chapters;
			let mapWithChapter = chapterArray.filter((data: any) => data.submilestoneId == chaperId);
			if (!_.isEmpty(mapWithChapter)) {
				courseService.getSubMilestoneTestContent(paramDetail.courseID, chaperId, isSubmilestone).then((milestoneArr: any) => {

					self.setState({ milestoneChaperListInner: milestoneArr })
					courseService.getGoalDriller(mapWithChapter[0]._id).then((drillerData: any) => {
						drillerData.level = 'concept';
						self.setState({ drillerData: drillerData })
					});
					self.setState({ panelId: self.state.panelId == '' ? chaperId : '' })
				});
			}

		}
		else {
			courseService.getChapterContent(paramDetail.courseID, paramDetail.milestoneId, chaperId).then((milestoneArr: any) => {
				self.setState({ milestoneChaperListInner: milestoneArr })
				courseService.getGoalDriller(chaperId).then((drillerData: any) => {

					drillerData.level = 'concept';
					self.setState({ drillerData: drillerData })
				});

				self.setState({
					panelId: self.state.panelId == '' ? chaperId : ''
				})
				this.setState({
					chapterId: chaperId,
				})
			});
		}



	}
	componentWillMount() {
		let paramDetail = this.getParamsDetail();
		courseService.getMilestoneTestContent(paramDetail.courseID, paramDetail.milestoneId).then((testArr: any) => {
			this.setState({ testContentListInner: testArr })
		});
	}
	displayTestContent(testId: string) {
		let self = this;
		let _getElement = document.getElementById("test" + testId) as HTMLImageElement;
		setTimeout(function () {
			if ((_getElement.getAttribute("src") || "").indexOf("add") > -1) {
				_getElement.setAttribute("src", "/assets/img/course/remove.png")
			} else {
				_getElement.setAttribute("src", "/assets/img/course/add.png")
			}
		}, 0)
		let paramDetail = this.getParamsDetail();
		courseService.getMilestoneTestContent(paramDetail.courseID, paramDetail.milestoneId).then((testArr: any) => {
			self.setState({ testContentListInner: testArr })
		});
		self.setState({ panelId: self.state.panelId == '' ? testId : '' })
	}

	getSelectedChapter(params: any, isContent: boolean = false) {
		let contentIds: any = [];
		let testIds: any = [];
		params.map((ob: any) => {
			if (ob.settings && !isContent) {
				testIds.push(ob._id)
				contentIds = []
			}
			else {
				contentIds.push(ob._id)
				testIds = []
			}

		});
		let paramDetail = this.getParamsDetail();
		let selectedData = {
			"packageId": paramDetail.courseID,
			"milestoneId": paramDetail.milestoneId,
			"chapterId": this.state.chapterId ? [this.state.chapterId] : [this.state.panelId],
			"contentIds": contentIds,
			"testIds": testIds
		}
		this.setState({ selectedDeleteData: selectedData });

	}

	deleteContent(value: {}) {
		if (!Object.keys(value).length) return
		var self = this;
		if (value) {

			courseService.deleteContentfromSyllabus(value).then((response: any) => {
				if (response) {
					//self.props.showMsg("Content has been combined successfuly !", 'success');
					location.reload();
				}
				else {
					//self.props.showMsg("Something went wrong! Please try again later", 'error');
				}
				this.setState({ selectedDeleteData: [] })

			});

		}
	}

	handleSuggestedCntentSelect = (selectedQuestions: any, chapterId: string, contentType: string) => {
		if (contentType == 'question') {
			selectedQuestions['content_Id'] = selectedQuestions._id;
			selectedQuestions['subjects'] = selectedQuestions.subjects;
		}
		this.setState({ selectedTempQuestions: [selectedQuestions], contentType: contentType, chapterId: chapterId });
		setTimeout(() => {
			this.handleAddContentClick();
		}, 500)
	}

	handleContentSelect = (selectedQuestions: any) => this.setState({ selectedTempQuestions: selectedQuestions });

	handleBackToTestpaperClick = (evt: any) => this.setState({ selectQuestionDialogOpen: false });

	handleAddContentClick = () => {
		let { selectQuestionDialogData, selectedTempQuestions, contentType, selectedChapter } = this.state;
		let { refreshMilestone, milestoneArr } = this.props;
		let dataSelect: any = [];
		let paramDetail = this.getParamsDetail();

		if (contentType == 'question') {
			let paramArr: any = {
				"milestoneId": paramDetail.milestoneId,
				"packageId": paramDetail.courseID,
			}
			if (selectedTempQuestions.length > 0) {
				selectedTempQuestions.map((ob: any) => {
					dataSelect.push(ob.content_Id)
				});
				paramArr.testIds = dataSelect;
				courseService.addMilestoneTest(paramArr).then((contentResponse: any) => {
					if (contentResponse.status == 200) {
						this.setState({
							selectQuestionDialogOpen: false,
							selectedTempQuestions: [],
							contentType: ""
						});
						this.props.showMsg(`Content added successfully`, "success");

						location.reload();
						this.displayContent(selectedChapter, false);
						window.location.reload();
						refreshMilestone();
					}
					else if (contentResponse.status == 404) {
						this.props.showMsg(contentResponse.message, "error");
					}
					else {
						this.setState({
							selectQuestionDialogOpen: false,
							selectedTempQuestions: [],
							contentType: ""
						});
						this.props.showMsg(`Kindly select Questions`, "error");
					}
				})
			}
		}
		else if (contentType == 'submilestone') {
			let paramArr: any = {
				"packageId": paramDetail.courseID
			}

			if (selectedTempQuestions.length > 0) {
				selectedTempQuestions.map((ob: any) => {
					dataSelect.push(ob.content_Id)
				});

				paramArr.testIds = dataSelect;
				paramArr.submilestoneId = this.state.chapterId ? this.state.chapterId : this.state.panelId;

				courseService.addSubMilestoneTest(paramArr).then((contentResponse: any) => {
					if (contentResponse.status == 200) {
						this.setState({
							selectQuestionDialogOpen: false,
							selectedTempQuestions: [],
							contentType: ""
						});
						this.props.showMsg(`Submilestone added successfully`, "success");
						location.reload();
					}
					else if (contentResponse.status == 404) {
						this.props.showMsg(contentResponse.message, "error");
					}
					else {
						this.setState({
							selectQuestionDialogOpen: false,
							selectedTempQuestions: [],
							contentType: ""
						});
						this.props.showMsg(`Kindly select Questions`, "error");
					}
				})
			}
		}
		else if (contentType == 'test') {

			let paramData: any = {
				"packageId": paramDetail.courseID,
				"milestoneId": paramDetail.milestoneId,
				"testIds": [
					selectedTempQuestions[0]._id
				]
			}
			courseService.addMilestoneTest(paramData)
				.then((res) => {
					location.reload()
				})
		}
		else {
			let paramArr: any = {
				"packageId": paramDetail.courseID,
				"milestoneId": paramDetail.milestoneId,
				"contentListing": [
					// {
					// 	"chapterId": "",
					// 	"contents": []
					// }
				]
			}

			selectedTempQuestions =  _.filter(selectedTempQuestions, (data:any)=> typeof(data['subjects']) != "undefined");
			
			if (selectedTempQuestions.length > 0) {
				selectedTempQuestions.map((ob: any) => {
					let chapters: string[] = [];
					ob.subjects.forEach((s: any) => {
						if (!s.subSubjects) {
							return;
						}

						s.subSubjects.forEach((ss: any) => {
							if (!ss.chapters) {
								return;
							}
							chapters = [...chapters, ...ss.chapters.map((c: any) => (c.chapterId._id ? c.chapterId._id : c.chapterId))]
						})
					});
					dataSelect.push({ "contentId": ob.content_Id, "type": ob.contentTypeCode, "chapters": chapters })
				});

				let milestoneChapters: any = _.get(milestoneArr, 'milestoneBasicDetail.chapters', []);
				milestoneChapters.forEach((mc: any) => {
					let masterIDs: string[] = _.get(mc, 'masterIds.masterIDs', []);
					if (!(masterIDs.length > 0)) {
						return;
					}

					dataSelect.forEach((d: any) => {
						masterIDs.forEach((m: string) => {
							if (d.chapters.includes(m)) {
								paramArr.contentListing.push({
									"chapterId": mc.masterIds._id,
									"contents": [d]
								})
							}
						})
					})
				})

				let selectedChapterId: any = this.state.chapterId ? this.state.chapterId : this.state.panelId;
				// paramArr.contentListing[0].chapterId = this.state.chapterId?this.state.chapterId:this.state.panelId;
				// paramArr.contentListing[0].contents = dataSelect;
				courseService.addContentInChapter(paramArr).then((contentResponse: any) => {
					if (contentResponse.status == 200) {
						this.setState({
							selectQuestionDialogOpen: false,
							selectedTempQuestions: []
						});
						this.props.showMsg(`Content added successfully`, "success");
						// location.reload();
						this.displayContent(_.get(paramArr, 'contentListing[0].chapterId', selectedChapterId), false);
						refreshMilestone();
					}
					else if (contentResponse.status == 404) {
						this.props.showMsg(contentResponse.message, "error");
					}
					else {
						this.props.showMsg(`Kindly select Questions`, "error");
					}
				})
			}
		}



	};
	handleChooseLibraryClick = (chapterId: string, type: string, status: string, isSubmilestone: boolean, libraryFor: string = '') => {
		const { globalDrillerData, drillerData, milestoneChaperList,selectedTempQuestions } = this.state;
		const { milestoneArr } = this.props;
		let selectedContent:any =  []
		let rightListArr: any = [];
		rightListArr = this.state.milestoneChaperList.length > 0 ? this.state.milestoneChaperList : [];
		
		let chapterData:any = _.find(milestoneArr.milestoneBasicDetail['chapters'], {chapterId: chapterId})
		let milestoneTestData: any = []

		if(chapterData && chapterData.hasOwnProperty('content')){
			if(chapterData.content.length > 0){
				_.forEach(chapterData['content'], (content)=> selectedContent.push({"content_Id": content.contentId}))

				if(selectedContent.length > 0){
					this.setState({selectedContent})
				}
			}

		}


		let goalsDriller: any = {};
		let contentSubTypeCode: string = "";
		if (libraryFor == 'global') {
			goalsDriller = globalDrillerData;
			const chapterIds = _.map(milestoneChaperList, (list: any) => list._id);
			if (chapterIds.length == 0 || _.isEmpty(goalsDriller)) {
				return;
			}
			goalsDriller['includedIds'] = chapterIds;
			if (type == 'testpapers') {
				contentSubTypeCode = 'full';
			}
		} else {
			if (type != 'question' && !isSubmilestone && libraryFor != "courseContent") {
				goalsDriller = {};
				goalsDriller.course = globalDrillerData.course
				goalsDriller.level = 'subject'
			}
			if (type != 'question' && !isSubmilestone && libraryFor == "courseContent") {
				goalsDriller = {};
				goalsDriller.course = globalDrillerData.course
				goalsDriller.subject = globalDrillerData.subject
				goalsDriller.subSubject = globalDrillerData.subSubject
				goalsDriller.includedIds = [chapterId]
				goalsDriller.level = 'chapter'
			}
			if (isSubmilestone) {
				type = "testpapers";
				let submilestoneId = chapterId;
				let includedChapters: any = []
				let chapters = milestoneArr.milestoneBasicDetail.chapters

				let submilestoneChapter = _.filter(chapters, (chapter: any) => chapter.submilestoneId == submilestoneId);

				_.forEach(submilestoneChapter, (data: any) => includedChapters.push(data.chapterId))

				contentSubTypeCode = 'full';
				// goalsDriller = {};
				goalsDriller.includedIds = includedChapters
			}
			
			if(type = "testpapers" ){
				contentSubTypeCode = 'full';

				if(milestoneArr.syllabus.length && milestoneArr.syllabus[0].milestoneTest.length) {
					milestoneTestData = milestoneArr.syllabus[0].milestoneTest
					
					_.forEach(milestoneTestData, (mtd:any) => selectedContent.push({"content_Id": mtd.testId}))
					if(selectedContent.length > 0){
						this.setState({selectedContent})
					}
				}
			}
		}

		let preSelectedFilterContent = {
			contentMenu: "all",
			goalsDriller,
			contentSubTypeCode,
			contentFilterData: [{
				filterValue: 'contentType',
				isSelected: true,
				filters: [{
					filterValue: type,
					isSelected: true,
					filters: [{
						filterValue: contentSubTypeCode,
						isSelected: true,
						filters: [],
					}]
				}]
			}, {
				filterValue: 'status',
				isSelected: true,
				filters: [{
					filterValue: "PUBLISHED",
					isSelected: true,
					filters: [],
				}]
			}]
		}
		if (status == "PUBLISHED" && type == "testpapers") {
			type = "question";
		}
		else if (isSubmilestone) {
			type = "submilestone";
		}

		if (['courseContent', 'global'].includes(libraryFor)) {
			// if adding content to course remove content type filter
			let contentFilterData: any = _.get(preSelectedFilterContent, 'contentFilterData', []);

			contentFilterData = _.filter(contentFilterData, (data: any) => data.filterValue != 'contentType');

			if (type != 'question' && !isSubmilestone) {
				let filterOfContent = {
					filterValue: "contentType",
					filters: [
						{
							filterValue: "studymaterial",
							filters: [],
							isSelected: true
						},
						{
							filterValue: "testpapers",
							filters: [],
							isSelected: true
						},

					],
					isSelected: true
				}
				contentFilterData.push(filterOfContent);
			}
			else if (isSubmilestone) {
				let filterOfContent = {
					filterValue: "contentType",
					filters: [

						{
							filterValue: "testpapers",
							filters: [],
							isSelected: true
						},

					],
					isSelected: true
				}
				contentFilterData.push(filterOfContent);
			}
			preSelectedFilterContent.contentFilterData = contentFilterData;
		}

		

		let selectedId = chapterId ? chapterId : this.state.panelId
		this.setState({
			chapterId: chapterId,
			selectQuestionDialogOpen: true,
			preSelectedFilterContent,
			contentType: type
		});
	};

	addContentDialog() {
		const {
			classes,
			courseDetails
		} = this.props;
		const {
			selectQuestionDialogOpen,
			selectQuestionDialogData,
			selectedTempQuestions,
			preSelectedFilterContent,
			selectedContent
		} = this.state;
		const otherDialogProps = {
			fullScreen: true
		};

		return (
			<MyPATDialog
				dialogOpen={selectQuestionDialogOpen}
				otherDialogProps={otherDialogProps}
				customDialogTitle={
					<>
						<Grid container justify="space-between" alignItems="center">
							<Grid item xs="auto">
								<Typography
									color="textPrimary"
									variant="body1"
									style={{ cursor: 'pointer' }}
									onClick={this.handleBackToTestpaperClick.bind(this)}
								>
									<BackIcon></BackIcon>
									<strong>Back to Course Milestone</strong>
								</Typography>
							</Grid>
							<Grid item xs />
							<Grid item xs="auto">
								<Typography variant="caption" inline>
									{selectedTempQuestions.length ? selectedTempQuestions.length : selectedContent.length }  Selected
				  				</Typography>
								<ResponseBasedACL
									response={_.get(courseDetails, 'aclMetaData', {})}
									responseKey='allowedTo'
									accessType={['EDIT']}
								>
									<Button
										variant="contained"
										color="primary"
										onClick={this.handleAddContentClick.bind(this)}
									>
										Add Content
									</Button>
								</ResponseBasedACL>
							</Grid>
						</Grid>
					</>

				}
			>
				<WithContent
					isInPopUp={true}
					selectedQuestions={selectedContent}
					onContentSelect={this.handleContentSelect.bind(this)}
					selectedFilterContent={preSelectedFilterContent}
					fromCourse={true}
					selectedContentCourse = {selectedContent}
				/>
			</MyPATDialog>
		)
	}
	deleteSubmilestone(submilestoneId: String) {
		let paramDetail = this.getParamsDetail();
		let { refreshMilestone } = this.props;
		let paramArr: any = {
			"submilestoneId": submilestoneId,
			"packageId": paramDetail.courseID,
			"milestoneId": paramDetail.milestoneId,
		}
		courseService.deleteSubmilestone(paramArr).then((milestoneResponse: any) => {
			if (milestoneResponse) {
				window.location.reload();
				refreshMilestone();
			}

		})
	}

	render() {
		let self = this;
		let { classes, courseData, milestoneArr, courseDetails } = this.props;
		let { milestoneChaperListInner, testContentListInner, panelId, selectedDeleteData, selectedChapter, milestoneChaperList, expansionIds } = this.state;
		let selectedId: any = ""
		let SyllabusList: any = [];
		let rightTestArrList: any = [{ "_id": "0", testId: "" }];
		let milestoneArrList = milestoneArr.syllabus || [];
		let rightListArr = milestoneArrList[0] || [];
		if (rightListArr) {
			rightListArr = rightListArr.subjects;

			if (rightListArr) {

				rightListArr = rightListArr[0].subSubjects[0].chapters;
			}
		}
		let rightList: any = [];
		rightListArr = self.state.milestoneChaperList.length > 0 ? self.state.milestoneChaperList : rightListArr;
		rightTestArrList = self.state.rightTestArrList.length > 0 ? self.state.rightTestArrList : rightTestArrList;


		if (rightListArr) {
			rightListArr.map(function (v: any, i: any) {

				if (v.isSubmilestone) { v.assignmentCount = v.tests.length }
				rightList.push(
					<MyPATExpansionPanel
						hasExpandIcon={false}
						defaultExpanded={false}
						panelProps={{
							expanded: expansionIds.includes(v._id) ? true : false,
							onChange: () => self.selectConcept(v._id, null, null)
						}}
						fullWidth={true}
						style={{ marginBottom: "10px" }}
						customCollapseTitle={
							<Grid onClick={() => self.displayContent(v._id, v.isSubmilestone)} container xs={12} >
								<Grid item xs={6}><Typography className={classes.primaryHeading} variant="h6" >
									{v.name}
								</Typography></Grid>
								<Grid item xs={3}><Typography className={classes.secondaryHeading}> {v.assignmentCount} Assignment</Typography></Grid>

								<div className={classes.rightIcon}>
									<img id={v._id} alt="no content" className={classes.rightIconIMG}
										src={expansionIds.includes(v._id) ? "/assets/img/course/remove.png" : "/assets/img/course/add.png"}
									/>
									{v.isSubmilestone
										?
										<DeleteOutlinedIcon onClick={(e) => { e.stopPropagation(); self.deleteSubmilestone(v._id) }} className={classes.deleteSubmilestone} />
										: ''
									}
								</div>

							</Grid>

						}
					>
						<ContentList
							cardFlag="chapter"
							onContentSelect={self.getSelectedChapter.bind(self)} 
							contentList={milestoneChaperListInner}
							listContent={() => self.displayContent(v._id, v.isSubmilestone)}
						/>
						<Grid container
							spacing={0}
							direction="column"
							alignItems="center"
							justify="center"
							style={{ minHeight: '100px' }}>
							<Grid item className={classes.center}>
								{milestoneChaperListInner.length == 0 ?
									<>
										<img alt="no content" className={classes.img} src="/assets/img/course/content3x.png" />
										<Typography variant="h6" gutterBottom>Let the Learning Begin!</Typography>
										<Typography variant="caption" gutterBottom>Add content from your vast Library and help
											students master this chapter.</Typography></>
									: ""}
								<ResponseBasedACL
									response={_.get(courseDetails, 'aclMetaData', {})}
									responseKey='allowedTo'
									accessType={['EDIT']}
								>
									<Button
										type="submit"
										color="primary"
										style={{ marginRight: "25px" }}
										onClick={e =>
											self.handleChooseLibraryClick(
												v._id,
												'all',
												"",
												v.isSubmilestone,
												'courseContent'
											)
										}
									>
										Add Content
								</Button>
								</ResponseBasedACL> 
							</Grid>
						</Grid>
						<SuggestedContentCard contentType="chapter" addSuggestedContent={self.handleSuggestedCntentSelect} chapterId={v._id} />
					</MyPATExpansionPanel>

				)
			})

		}

		let rightTestList: any = [];
		if (rightTestArrList) {
			rightTestArrList.map(function (v: any, i: any) {
				rightTestList.push(<MyPATExpansionPanel
					hasExpandIcon={false}
					defaultExpanded={false}
					fullWidth={true}
					style={{ marginBottom: "10px" }}
					customCollapseTitle={

						<Grid onClick={() => self.displayTestContent(v._id)} container xs={12} >
							<Grid item xs={3}><Typography className={classes.primaryHeading} variant="h6" >
								Milestone Test
									</Typography></Grid>
							<Grid item xs={3}><img src="/assets/img/course/GoalIcon.png" alt="GoalIcon" /></Grid>
							<Grid item xs={3}><Typography className={classes.secondaryHeading}>{testContentListInner.length} Assignments</Typography></Grid>
							<div className={classes.rightIcon}>
								<img id={"test" + v._id} alt="no content" className={classes.rightIconIMG} src="/assets/img/course/add.png" />
							</div>
						</Grid>

					}
				>
					<ContentList
						cardFlag="test"
						onContentSelect={self.getSelectedChapter.bind(self)}
						contentList={testContentListInner}
						listContent={() => self.displayTestContent(v._id)}
					/>
					<Grid container
						spacing={0}
						direction="column"
						alignItems="center"
						justify="center"
						style={{ minHeight: '100px' }}>
						<Grid item className={classes.center}>
							{testContentListInner.length == 0 ?
								<><Typography variant="h6" gutterBottom>Assessment is the key!</Typography>
									<Typography variant="caption" gutterBottom>Add Tests covering the syllabus of this milestones, to evaluate progress and performance</Typography>
								</> : ""}
							<Button
								type="submit"
								color="primary"
								style={{ marginRight: "25px" }}
								onClick={e =>
									self.handleChooseLibraryClick(
										v._id,
										'testpapers',
										'PUBLISHED',
										false,
										'testPapers'
									)
								}
							>
								Add Test
								</Button>
						</Grid>
					</Grid>
					<SuggestedTestCard contentType="test" addSuggestedContent={self.handleSuggestedCntentSelect} chapterId={v.testId} />
				</MyPATExpansionPanel>

				)
			})
		}

		const Syllabus: any = () => _.map(milestoneArrList, (milestoneD: any, milestoneI: number) => (
			<Grid
				container
				key={`class-${milestoneI}`}
				className={cx(classes.marginTop10, classes.marginBottom20, classes.headof0)}
			>
				<Grid item xs={12} className={cx(classes.syllabusHead, classes.headLevel0)}>
					<ArrowDown className={milestoneD.isGreen ? classes.isGreen : classes.isDefault} />
					<img src="/assets/img/course/folder.png" alt="Folder" className={classes.iconCss} />
					<Typography inline variant="body2">Class {milestoneD.class}</Typography>
				</Grid>

				{/* generate subjects */}
				<Grid item xs={12}>
					{_.map(milestoneD.subjects, (subjectD: any, subjectI: number) => (
						<Grid
							container
							key={`subject-${subjectD._id}`}
							className={classes.head}
						>
							<Grid item xs={12} className={cx(classes.syllabusHead, classes.headLevel1)}>
								<ArrowDown className={subjectD.isGreen ? classes.isGreen : classes.isDefault} />
								<img src="/assets/img/course/book.png" alt="book" className={classes.iconCss} />
								<Typography inline variant="body2">
									{subjectD.name}
									<Typography inline variant="caption">
										{` (${subjectD.subSubjects.length || 0} Sub Subjects)`}
									</Typography>
								</Typography>
							</Grid>

							{/* generate subsubjects */}
							<Grid item xs={12}>
								{_.map(subjectD.subSubjects, (subSubjectD: any, subSubjectI: number) => (
									<Grid
										container
										key={`subject-${subSubjectD._id}`}
										className={_.isEqual(selectedChapter, subSubjectD._id) ? classes.activeHead : ''}
									>
										<Grid item xs={12}
											className={cx(classes.syllabusHead, classes.headLevel2)}
											onClick={() => self.selectMyList(subSubjectD.chapters, subSubjectD._id)}
										>
											<RoundedCircle className={subSubjectD.isGreen ? classes.isGreen : classes.isDefault} />
											<img src="/assets/img/course/syllabus.png" alt="subsubject" className={classes.iconCss} />
											<Typography inline variant="body2">
												{subSubjectD.name}
												<Typography inline variant="caption">
													{` (${subSubjectD.chapters.length || 0} Chapters)`}
												</Typography>
											</Typography>
										</Grid>

										{/* generate concepts */}
										<Grid item xs={12} className={classes.headlevelConcept} >
											{_.map(subSubjectD.chapters, (chapterD: any, chapterI: number) => !chapterD.isSubmilestone ? (

												<Grid
													container
													key={`chapter-${chapterD._id}`}
													className={classes.headConceptBorder}
												>
													<Grid item xs={12} className={cx(classes.syllabusHead, classes.headLevel3)}
														onClick={() => this.selectConcept(chapterD._id, subSubjectD.chapters, subSubjectD._id)}
													>
														{/* <RoundedCircle className={chapterD.isGreen ? classes.isGreen : classes.isDefault} /> */}
														<img src="/assets/img/course/concept.png" alt="subsubject" className={classes.iconCss} />
														<Typography inline variant="body2" className={classes.textWithImg}>
															{chapterD.name}
															<Typography inline variant="caption">
																{` (${chapterD.conceptCount} Concepts)`}
															</Typography>
														</Typography>
													</Grid>
												</Grid>
											) : '')}
										</Grid>
									</Grid>
								))}
							</Grid>
						</Grid>
					))}
				</Grid>
			</Grid>
		));

		let courseID = (window.location.href)
		courseID = courseID.substring(courseID.lastIndexOf("/") + 1, courseID.length)

		return (
			<Grid container className={cx(classes.marginTop20, classes.marginBottom20)}>
				<Grid item xs={3}>
					<Typography variant="title" style={{ padding: "12px" }}>
						Syllabus
					</Typography>
					<Grid container xs={11} className={classes.wrapperMain} >
						<Syllabus />
					</Grid>
				</Grid>
				<Grid item xs={9}>
					<Grid
						container
						direction="row"
						alignContent="center"
						justify="space-between"
					>

						<Grid xs={4}>
							<Typography variant="h6" style={{ padding: "10px" }}>
								Course Content
								</Typography>
						</Grid>
						<Grid xs={6} style={{ padding: "10px" }} container justify="flex-end" alignItems="flex-end">
							<ResponseBasedACL
								response={_.get(courseDetails, 'aclMetaData', {})}
								responseKey='allowedTo'
								accessType={['EDIT']}
							>
								<Button
									variant="contained"
									type="submit"
									color="primary"
									style={{ marginRight: "25px" }}
									onClick={e =>
										this.handleChooseLibraryClick("", "all", "", false, 'global')
									}
								>
									Add Content
								</Button>
							</ResponseBasedACL>
							<Grid item xs={1} className={classes.vertHeaderActions}>
								<ResponseBasedACL
									response={_.get(courseDetails, 'aclMetaData', {})}
									responseKey='allowedTo'
									accessType={['EDIT']}
								>
									<ContentMoreMenu mileStoneAction={selectedDeleteData} clicked={this.deleteContent} />
								</ResponseBasedACL>
							</Grid>
						</Grid>
					</Grid>

					{this.addContentDialog()}
					<Grid container xs={12} className={classes.wrapperCollap} >
						{rightList}
						{rightTestList}
					</Grid>
				</Grid>
			</Grid>
		)
	}
}

const mapStateToProps = (state: any) => ({
	courseData: state.courseData.courseData.list
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
	{
		showMsg: showMsg,
		// ServerAlertAction
	},
	dispatch
);


// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MilestoneDetailContent));
